const indexItems = [
  {
    title: '刃牙第一部',
    chapters: '371话',
    status: '已完结',
    desc: '范马刃牙的起点，地下斗技场篇，奠定系列基础。',
    href: '#carousel',
  },
  {
    title: '刃牙II',
    chapters: '312话',
    status: '已完结',
    desc: '最凶死刑犯篇与中国大擂台篇，系列巅峰。',
    href: '#carousel',
  },
  {
    title: '范马刃牙',
    chapters: '312话',
    status: '已完结',
    desc: '地上最强父子决战，皮可篇与武藏开场。',
    href: '#carousel',
  },
  {
    title: '刃牙道',
    chapters: '198话',
    status: '已完结',
    desc: '宫本武藏复活篇，剑与拳的跨时代对决。',
    href: '#carousel',
  },
  {
    title: '刃牙道II',
    chapters: '连载中',
    status: '连载中',
    desc: '相扑道篇，力士与格斗家的激烈碰撞。',
    href: '#carousel',
  },
  {
    title: '刃牙外传合集',
    chapters: '若干',
    status: '不定期',
    desc: '花山薰外传、镐昴升外传等人气角色故事。',
    href: '#carousel',
  },
  {
    title: '动画改编对照',
    chapters: '-',
    status: '专题',
    desc: '漫画与动画情节对照，发现动画未收录的精彩细节。',
    href: '#media',
  },
];

export default function IndexSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          主题索引
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画全系列作品目录，快速定位你想看的章节
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
              className="group flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <span className="font-heading text-sm font-bold text-primary-600">{i + 1}</span>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className={`px-1.5 py-0.5 text-[10px] font-medium rounded-full whitespace-nowrap ${
                    item.status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.status}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed mb-1">{item.desc}</p>
                <span className="text-[11px] text-foreground-500">{item.chapters}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}